/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_D2dInputs */

const en_mk_sol_operasional_d2d = /** @type {(inputs: Mk_Sol_Operasional_D2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format and rules are written as a Skill, so the output is identical every month regardless of who is on duty.`)
};

const id_mk_sol_operasional_d2d = /** @type {(inputs: Mk_Sol_Operasional_D2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format dan aturannya ditulis sebagai Skill, jadi hasilnya sama tiap bulan tanpa bergantung siapa yang mengerjakan.`)
};

/**
* | output |
* | --- |
* | "Format and rules are written as a Skill, so the output is identical every month regardless of who is on duty." |
*
* @param {Mk_Sol_Operasional_D2dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_d2d = /** @type {((inputs?: Mk_Sol_Operasional_D2dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_D2dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_d2d(inputs)
	return en_mk_sol_operasional_d2d(inputs)
});